import { lazy, Suspense, useContext } from 'react'
import type { ComponentProps } from 'react'
import type TokenAboutEditorInner from '@/components/TokenAboutEditorInner'
import { WalletReadyContext } from '@/lib/walletContext'

/**
 * Client-only boundary for the creator About editor.
 *
 * The inner editor uses wagmi `useWalletClient` so Save can open the connected
 * AppKit wallet sign modal. Loading it lazily keeps the Node prerender path
 * free of WalletConnect `require("ws")`.
 *
 * DO NOT convert this back into a static import.
 */
const TokenAboutEditorInnerLazy = lazy(() => import('@/components/TokenAboutEditorInner'))

type TokenAboutEditorProps = ComponentProps<typeof TokenAboutEditorInner>

function TokenAboutEditor(props: TokenAboutEditorProps) {
  const ready = useContext(WalletReadyContext)
  if (!ready)
    return null

  return (
    <Suspense fallback={null}>
      <TokenAboutEditorInnerLazy {...props} />
    </Suspense>
  )
}

export default TokenAboutEditor
